import React from 'react';

export default function Placeholder({ children, className }) {
  return <div className={`text-muted fs-sm text-center p-3 ${className}`}>{children}</div>;
}
